export default function DirectoryEditorial({ sections = [] }) {
  return (
    <section className="site-shell py-12 sm:py-16">
      <div className="grid gap-5 lg:grid-cols-2">
        {sections.map((section) => (
          <article key={section.title} className="soft-card p-5 sm:p-7">
            <h2 className="text-2xl font-black tracking-tight text-neutral-950">{section.title}</h2>
            <p className="mt-4 text-base leading-8 text-neutral-700">{section.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
